export default __webpack_public_path__ + "static/media/56.cd6c70b8.png";